
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import OrderedCheckBox from "@/components/utils/PopulateForms/components/OrderedCheckBox.vue";
import { nameInfoType } from "@/types/Application/CommonInformation";
import { childrenInfoSurveyInfoType, yourInformationInfoDataInfoType } from '@/types/Application/CommonInformation/Pdf';
import { getYourInformationResults } from '@/components/utils/PopulateForms/PopulateCommonInformation';
import { childDetailsDataInfoType } from '@/types/Application/FamilyLawMatter';
import { existingOrdersInfoType } from '@/types/Application/FamilyLawMatter/Pdf';

@Component({
    components:{
        UnderlineForm,
        CheckBox,
        OrderedCheckBox        
    }
})
export default class Form1Layout extends Vue {

    @Prop({required:true})
    result!: any;

    @Prop({required:true})
    selectedPathways!: string[];
    
    @applicationState.State
    public applicantName!: nameInfoType;  

    dataReady = false;   

    otherPartyInfo=[];
    additionalOtherParties = [];
    firstOtherParty = {} as any;
    yourInfo = {} as yourInformationInfoDataInfoType;
    childrenInfo: childrenInfoSurveyInfoType[] = []; 
    applicantList = [];
    childRelatedType = false;
    filingLocationReason = '';  
    existingOrders = {} as existingOrdersInfoType;
    existingFileNumber = '';
    
    childrenFields=[
        {key:"fullName", label:"Child's full name",                   tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:30%;"},
        {key:"dob",      label:"Child's date of birth (mmm/dd/yyyy)", tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"}
    ]
   
    mounted(){
        this.dataReady = false;
        this.extractInfo();     
        this.dataReady = true;
    } 

    public extractInfo(){        
        
        if (this.result.filingLocationSurvey?.ExistingFamilyCase == 'y') {
            this.filingLocationReason = 'It is the court location where my existing case with the same party/parties is filed';
        } else if (this.result.filingLocationSurvey?.ExistingFamilyCase == 'n' && this.result.filingLocationSurvey?.filingLocationReason){
            this.filingLocationReason = this.result.filingLocationSurvey.filingLocationReason;
        }

        this.existingOrders = {existingFlm: false, existingPO: false}

        this.existingOrders.existingFlm = this.result.flmBackgroundSurvey?.ExistingOrdersFLM == 'y';
        this.existingOrders.existingPO =  this.result.flmBackgroundSurvey?.existingPOOrders == 'y';

        this.existingFileNumber = this.result.filingLocationSurvey?.ExistingFileNumber? this.result.filingLocationSurvey.ExistingFileNumber : ''

        this.otherPartyInfo=this.getOtherPartyInfo()        
        this.firstOtherParty = this.otherPartyInfo[0];
        if (this.otherPartyInfo?.length > 1) {
            this.otherPartyInfo.splice(0,1)
            this.additionalOtherParties = this.otherPartyInfo;
        }   
        this.childrenInfo = this.getChildrenInfo();     
        this.yourInfo = this.getYourInfo();
    }   
    
    public getChildrenInfo(){
        
        const selectedPathways = this.result?.flmQuestionnaireSurvey?this.result?.flmQuestionnaireSurvey:[];
        
        if (selectedPathways.includes("parentingArrangements") || 
                selectedPathways.includes("childSupport") ||
                selectedPathways.includes("contactWithChild") ||
                selectedPathways.includes("guardianOfChild")){
            this.childRelatedType = true;
        } else {
            this.childRelatedType = false;
        }

        const childrenInfo: childrenInfoSurveyInfoType[] = [];
        let childInfo = {} as childrenInfoSurveyInfoType;
        const childData: childDetailsDataInfoType[] = this.result?.childrenInfoSurvey? this.result.childrenInfoSurvey: [];
        
        if(this.childRelatedType){
            for (const child of childData){            
                childInfo = {fullName: '', dob:'', myRelationship: '', otherPartyRelationship: '', currentSituation: ''};
                childInfo.fullName = Vue.filter('getFullName')(child.name);
                childInfo.dob = Vue.filter('beautify-date')(child.dob);            
                childrenInfo.push(childInfo)
            }        
        }
        else
            childrenInfo.push({fullName: '', dob:'', myRelationship: '', otherPartyRelationship: '', currentSituation: ''});
          

        return childrenInfo;
    }

    public getYourInfo(){           

        if(this.result?.yourInformationSurvey){
            return getYourInformationResults(this.result?.yourInformationSurvey); 
        } 
        else
            return {} as yourInformationInfoDataInfoType
    }

    public getOtherPartyInfo(){

        let OpInformation = [
            {            
                dob: 'unknown',
                name: {'first': '','middle': '', 'last': ''},
                address: '',
                contactInfo: ''
                
            }               
        ];        

        if (this.result.otherPartyCommonSurvey?.length > 0){
            OpInformation = [];  
 
            for(const party of this.result.otherPartyCommonSurvey){
                const otherParty = {            
                    dob: '',
                    name: {'first': '','middle': '', 'last': ''},
                    address: '',
                    contactInfo: '',
                    lawyer:''
                }                

                if (party['knowDob'] == 'y' &&  party['dob'])
                    otherParty.dob = party['dob']

                if (party['name'])
                    otherParty.name = party['name']
                
                if (party['address'])
                    otherParty.address = party['address']
                
                if (party['contactInfo'])
                    otherParty.contactInfo = party['contactInfo']
                
                if (party.lawyer)
                    otherParty.lawyer = party.lawyer
                
                OpInformation.push(otherParty)
            }
        } 

        return OpInformation
    }    
 
}
